import store from '@/store/store'

export default function adminRequireAuth(to, from, next) {
  if (store.getters['auth/token']) {
    next()
    return
  } else {
    next({
      path: '/admin/login',
      query: {
        redirect: localStorage.getItem('next_route_admin') ? localStorage.getItem('next_route_admin') : to.fullPath
      }
    })
    return
  }
}
